module.exports = __webpack_public_path__ + "static/img/xueshu1.3d0450d4.webp";